import { parse } from 'qs';
import trimStart from 'lodash/trimStart';
import { getBrandId } from '../config';
import { MIN_PROMO_CODE_LENGTH, PROMO_PARAM_MAPPING } from '../constants/promoParams';

export function parsePromoParams(queryString) {
  if (!queryString) {
    return null;
  }

  const params = parse(trimStart(queryString, '?'));

  const { promo, utm_source, utm_campaign, utm_medium, utm_content, utm_term, pid, clickid, http_referer } =
    params || {};

  if (!promo || promo.length < MIN_PROMO_CODE_LENGTH) {
    return null;
  }

  const promoCode = promo.length >= 16 ? promo.slice(-16) : promo;

  return {
    promoCode,
    casinoBrandId: getBrandId(),
    utmSource: utm_source || null,
    utmCampaign: utm_campaign || null,
    utmMedium: utm_medium || null,
    utmContent: utm_content || null,
    utmTerm: utm_term || null,
    pid: pid || null,
    clickid: clickid || null,
    httpReferer: http_referer || document.referrer || null,
    ip: null,
  };
}

export function arePromoParamsDifferent(currentParams, previousParams) {
  if (!currentParams || !previousParams) {
    return true;
  }

  const normalize = (val) => (val === undefined || val === null ? null : val);

  if (normalize(currentParams.promoCode) !== normalize(previousParams.promoCode)) {
    return true;
  }

  return Object.keys(PROMO_PARAM_MAPPING).some((key) => {
    if (key === 'promo') {
      return false;
    }

    const mappedKey = PROMO_PARAM_MAPPING[key];
    return normalize(currentParams[mappedKey]) !== normalize(previousParams[mappedKey]);
  });
}

export async function getUserIP() {
  try {
    if (window.appConfig && window.appConfig.clientIp) {
      return window.appConfig.clientIp;
    }

    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();

    return data.ip;
  } catch (error) {
    return null;
  }
}

export function buildVisitorRequestBody(params) {
  const requiredFields = ['promoCode', 'casinoBrandId'];

  return Object.keys(params).reduce((result, key) => {
    const value = params[key];

    if (requiredFields.includes(key)) {
      result[key] = value;
    } else if (key === 'referrerUserId' && value != null) {
      result[key] = String(value);
    } else {
      result[key] = value || null;
    }

    return result;
  }, {});
}

export function parseOldBtagParams(btag) {
  if (!btag) {
    return null;
  }

  try {
    const data = JSON.parse(btag);

    return {
      promoCode: data.promo_code || null,
      utmSource: data.utm_source || null,
      utmCampaign: data.utm_campaign || null,
      utmMedium: data.utm_medium || null,
      utmContent: data.utm_content || null,
      utmTerm: data.utm_term || null,
      pid: data.pid || null,
      clickid: data.clickid || null,
      httpReferer: data.http_referer || null,
    };
  } catch (e) {
    return null;
  }
}
